import React from 'react';

interface AnimatedBorderBadgeProps {
  text: string;
  className?: string;
  showPulsingDot?: boolean;
  surfaceClassName?: string;
}

export function AnimatedBorderBadge({ text, className = '', showPulsingDot = false, surfaceClassName = 'bg-hero-human' }: AnimatedBorderBadgeProps) {
  return (
    <div className={`inline-block ${className}`}>
      <div className="relative">
        {/* Base container with glowing border animation */}
        <div className={`glow-border ${surfaceClassName} border border-neutral-300/70 rounded-full px-4 py-1.5 sm:px-5 sm:py-2 inline-flex items-center gap-2`}>
          {/* Content */}
          {showPulsingDot && (
            <div className="pulse-green w-2 h-2 rounded-full bg-green-500" />
          )}
          <span className="text-xs sm:text-sm font-normal text-neutral-700 tracking-wide">
            {text}
          </span>
        </div>
      </div>

      {/* Glowing border pulse animation */}
      <style>{`
        .glow-border {
          animation: border-glow 2s ease-in-out infinite;
        }

        @keyframes border-glow {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(180, 210, 240, 0),
                        0 0 0 0 rgba(180, 210, 240, 0);
          }
          50% {
            box-shadow: 0 0 20px 2px rgba(180, 210, 240, 0.4),
                        0 0 30px 4px rgba(180, 210, 240, 0.2);
          }
        }

        .pulse-green {
          animation: pulse-green 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        @keyframes pulse-green {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
}
